import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectIsCompilation } from '../../../selectors/pagination';
import { ShowAllButtonContainer } from '../ShowAllButtonContainer';
import { ShowMoreButtonContainer } from '../ShowMoreButtonContainer';

export const ShowButtonContainer = () => {
  const isCompilation = useSelector(selectIsCompilation);

  return isCompilation ? <ShowAllButtonContainer /> : <ShowMoreButtonContainer />;
};
